import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Veloitus maksutavasta',
    [BillingMode.InternalInvoicing]: 'Veloitus myynnistä',
    active: 'Aktiivinen',
    on_trial: 'Kokeilujaksolla',
    launch_pending: 'Odottaa julkaisupäivää',
    billing_disabled: 'Laskutus pois käytöstä',
    on_grace_period: 'Maksuajan pidennyksellä',
    past_due: 'Erääntynyt',
    cancelled: 'Peruutettu',
  },
};
